import http from '../shared/HttpCommon';
import { Dispatch, SetStateAction } from 'react';
import { IPlatform } from '../shared/interfaces/IPlatform';
import { CanceledError } from 'axios';

const getPlatforms = async (loading: Dispatch<SetStateAction<boolean>>, signal: AbortSignal) => {
  try {
    loading(true);
    const { data } = await http.get('/platforms', { signal });
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const getPlatformId = (label: string, platforms: IPlatform[]) => {
  return platforms.find((value) => value.label === label)?.id || -1;
};

const getPlatformName = (platformId: number, platforms: IPlatform[]) => {
  return getLocalPlatform(platformId, platforms).label;
};

const getLocalPlatform = (platformId: number, platforms: IPlatform[]) => {
  const search = platforms.find((v) => platformId === v.id);
  if (!search) {
    console.error('Unknown platform with platformId: ' + platformId);
    return {
      label: 'Unknown platform',
      skipBackdated: false,
      skipBackdatedAbove: -1,
    };
  } else {
    return search;
  }
};

const getPlatformID = async (id: number, signal: AbortSignal) => {
  try {
    const { data } = await http.get(`/platforms/${id}`, {});
    return data;
  } catch (error) {
    console.error(error);
  }
};

const getPseudoGoogle = () => {
  return {
    heighest: 5,
    lowest: 1,
    url: '',
    id: -2,
    label: 'googleplace',
    name: 'Google',
    skipBackdated: false,
    skipBackdatedAbove: -1,
  };
};

const deletedCanBeOutdated = (platform: string) => {
  return platform == 'trustpilot';
};

const PlatformService = {
  getPlatforms,
  getPlatformId,
  getPlatformID,
  getPlatformName,
  getLocalPlatform,
  getPseudoGoogle,
  deletedCanBeOutdated,
};

export default PlatformService;
